<template lang="pug">
  .b2b-page-orders-emits
    ods-module.box-card
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("order.order_detail.download_pdf_buttons_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadOrderPdf')
                    | {{ $t('order.order_detail.download_pdf_buttons') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.download_original_signed_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canViewOrderOriginal && orderDetailForm.pathOrderOriginal'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadOriginal')
                    | {{ $t('invoice_detail.buttons.download_original_signed') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.download_metadata_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canViewOrderMetadata && orderDetailForm.pathOrderMetadata'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadMetadata')
                    | {{ $t('invoice_detail.buttons.download_metadata') }}
    ods-module.collapse
      ods-accordion(v-model='activateDetail', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('msg_generics.detail') }}

          ods-form(
            ref='orderDetailForm',
            :model='orderDetailForm',
            :rules='orderDetailFormRules',
            label-width='14rem',
            label-position='top',
            size='small',
            status-icon)
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item.moreSpace(
                    prop='sellerName',
                    :label='$t("order.order_entity_table.seller")'
                    style='margin-top: 0px;')
                    ods-input(
                      readonly,
                      v-model='orderDetailForm.sellerName')
            ods-table(
              :data='orderDetailForm.sellerCentres'
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='code',
                width='160'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.code.label")')
              ods-table-column(
                prop='description',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.name.label")')
              ods-table-column(
                prop='centreRoleTypeCode',
                width='190'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.role.label")',
                :formatter='formatterRole')
              ods-table-column(
                prop='address',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.address.label")')
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item.moreSpace(
                  prop='buyerName',
                  :label='$t("order.order_entity_table.buyer")')
                  ods-input(
                    readonly,
                    v-model='orderDetailForm.buyerName')
            ods-table(
              :data='orderDetailForm.buyerCentres'
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='code',
                width='160'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.code.label")')
              ods-table-column(
                prop='description',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.name.label")')
              ods-table-column(
                prop='centreRoleTypeCode',
                width='190'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.role.label")',
                :formatter='formatterRole')
              ods-table-column(
                prop='address',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.address.label")')
            ods-row(type='flex')
              ods-col(:span='6')
                ods-form-item(
                  prop='orderNumber',
                  :label='$t("order.order_entity_table.num_order")')
                  ods-input(
                    readonly,
                    v-model='orderDetailForm.orderNumber')
              ods-col(:span='6')
                ods-form-item(
                  prop='orderType',
                  :label='$t("order.filters.orderType.placeholder")')
                  ods-input(
                    readonly,
                    v-model='orderDetailForm.orderType')
              ods-col(:span='6',
                v-if='orderDetailForm.orderSubType !== null')
                ods-form-item(
                  prop='orderSubType',
                  :label='$t("order.filters.orderSubType.placeholder")')
                  ods-input(
                    readonly,
                    v-model='orderDetailForm.orderSubType')
              ods-col(:span='6')
                ods-form-item(
                  prop='statusId',
                  :label='$t("order.order_entity_table.status")')
                  ods-input(
                    readonly,
                    v-model='orderDetailForm.statusId')
            ods-row(type='flex')
              ods-col(:span='6')
                ods-form-item(
                  prop='issueDateTime',
                  :label='$t("order.order_entity_table.date_issue")')
                  ods-input(
                    readonly,
                    v-model='issueDateTimeFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='deliveryDateTimeFrom',
                  :label='$t("order.order_entity_table.delivery_date_from")')
                  ods-input(
                    readonly,
                    v-model='deliveryDateFromFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='deliveryDateTimeTo',
                  :label='$t("order.order_entity_table.delivery_date_to")')
                  ods-input(
                    readonly,
                    v-model='deliveryDateToFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='creationDateTime',
                  :label='$t("order.order_entity_table.date_creation")')
                  ods-input(
                    readonly,
                    v-model='creationDateTimeFormatted')
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item(
                  :label='$t("order.order_entity_table_detail.notes")',
                  prop='notes')
                  ods-input(
                    type='textarea',
                    readonly,
                    v-model='orderDetailForm.notes')
            ods-row(type='flex')
              ods-col(:span='4')
                ods-form-item(
                  v-if='canChangeStatusOrder',
                  :label='$t("order.order_detail.change_state.label")',
                  prop='statusCode')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='orderDetailForm.statusCode',
                    :disabled='!canChangeStatusOrder'
                    filterable,
                    clearable,
                    :placeholder='$t("order.order_detail.change_state.placeholder")'
                    @change='changeStatus')
                    ods-option(
                      v-for='option in optionsFilterStatusOrder',
                      :key='option.id',
                      :label='$t("order_status." + option.code)',
                      :value='option.code')
              ods-col(:span='2')
              ods-col(:span='16')
                ods-form-item(
                  v-if='canChangeStatusOrder && orderDetailForm.statusCode'
                  :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
                  prop='observations')
                  ods-input(v-model='orderDetailForm.observations')

    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('order.order_detail.order_lines') }}
            span.info(v-show='!ordersEmitLine.length') {{ $t('order.order_detail.order_line_no_data') }}
          //- Filtro fecha entrega
          div(style="text-align: right; margin-bottom: 10px;")
            span.dateFilter {{ $t('order.filters.delivery_date.value') }}
            ods-date-picker(
              v-model="deliveryDateFromFilter",
              type='datetime',
              prefixIcon='ods-icon-calendar',
              :placeholder='$t("msg_generics.datepicker.start_placeholder")'
              size='deci')
            ods-date-picker(
              v-model="deliveryDateToFilter",
              type='datetime',
              prefixIcon='ods-icon-calendar',
              default-time='23:59:59',
              :placeholder='$t("msg_generics.datepicker.end_placeholder")'
              size='deci')
          //- Tabla lineas pedido
          ods-table(
            v-if='ordersEmitLine.length > 0 ',
            :data='ordersEmitLine',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            @selection-change='handleSelectionChange',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              type='selection',
              width='55')
            ods-table-column(
            prop='lineNumber',
            width='75'
            :label='$t("order.order_entity_table_detail.lineNumber")')
            ods-table-column(
              prop='itemCode',
              width='100'
              v-if='isShowItemCodeLinesEmit'
              :label='$t("order.order_entity_table_detail.itemCode")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='itemCodeSeller',
              width='155'
              v-if='isShowItemCodeSellerLinesEmit'
              :label='$t("order.order_entity_table_detail.itemCodeSeller")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='itemCodeBuyer',
              width='160'
              v-if='isShowItemCodeBuyerLinesEmit'
              :label='$t("order.order_entity_table_detail.itemCodeBuyer")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='gtin14Code',
              width='160'
              v-if='isShowGtin14CodeLinesEmit'
              :label='$t("order.order_entity_table_detail.gtin14Code")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='description',
              v-if='isShowDescriptionLinesEmit'
              min-width='460'
              :label='$t("order.order_entity_table_detail.description")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='100'
              prop='quantity',
              v-if='isShowQuantityLinesEmit'
              align='right',
              :label='$t("order.order_entity_table_detail.quantity")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='measure',
              v-if='isShowMeasureLinesEmit'
              :label='$t("order.order_entity_table_detail.measure")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='135'
              prop='quantityTradeUnit',
              v-if='isShowQuantityTradeUnitLinesEmit'
              align='right',
              :label='$t("order.order_entity_table_detail.quantityTradeUnit")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='180'
              prop='unitOfMeasureTradeUnit',
              v-if='isShowUnitOfMeasureTradeUnitLinesEmit'
              :label='$t("order.order_entity_table_detail.measureTradeUnit")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='140'
              prop='quantityRemaining',
              v-if='isShowQuantityRemainingEmit'
              align='right',
              :label='$t("order.order_entity_table_detail.quantityRemaining")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='115'
              prop='netPrice',
              v-if='isShowNetPriceLinesEmit'
              align='right',
              :label='$t("order.order_entity_table_detail.netPrice")',
              :show-overflow-tooltip='true',
              :formatter='formatterDecimal')
            ods-table-column(
              width='115'
              prop='grossPrice',
              v-if='isShowGrossPriceLinesEmit'
              align='right',
              :label='$t("order.order_entity_table_detail.grossPrice")',
              :show-overflow-tooltip='true',
              :formatter='formatterDecimal')
            ods-table-column(
              width='80'
              prop='currency',
              v-if='isShowCurrencyLinesEmit'
              :label='$t("order.order_entity_table_detail.currency")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='totalAmount',
              v-if='isShowTotalAmountLinesEmit'
              width='150'
              align='right',
              :label='$t("order.order_entity_table_detail.totalAmount")',
              :show-overflow-tooltip='true',
              :formatter='formatterDecimal')
            ods-table-column(
              width='160'
              prop='centreDeliveryPoint',
              :label='$t("order.order_entity_table_detail.delivery_centre")',
              v-if='isShowCentroEntregaLinesEmit',
              :filters="deliveryCentreFilters",
              :filter-method='filterDeliveryCentreHandler')
                template(slot-scope='scope')
                  ods-tooltip(placement='top-end')
                    template(slot='content')
                      | {{ scope.row.centreDeliveryPoint }}
                      br
                      | {{ scope.row.centreDeliveryPointTooltip }}
                    div.text-overflow-tooltip
                      | {{ scope.row.centreDeliveryPoint }}
            ods-table-column(
              width='150'
              prop='deliveryDateFrom',
              v-if='isShowDeliveryDateFromLinesEmit'
              :label='$t("order.order_entity_table.delivery_date_from")',
              :show-overflow-tooltip='true',
              :formatter='dateFormatted',
              sortable)
            ods-table-column(
              width='150'
              prop='deliveryDateTo',
              v-if='isShowDeliveryDateToLinesEmit'
              :label='$t("order.order_entity_table.delivery_date_to")',
              :show-overflow-tooltip='true',
              :formatter='dateFormatted',
              sortable)
            ods-table-column(
              prop='status',
              v-if='isShowStatusLinesEmit'
              :label='$t("order.order_entity_table_detail.status")',
              :show-overflow-tooltip='true',
              :formatter='formatterStatus')
            ods-table-column(
              :render-header='renderHeaderActions',
              width='120')

    ods-module.collapse
      ods-accordion(v-model='activateChargeDiscounts', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('order.order_detail.charge_discount') }}
            span.info(v-show='!chargesDiscounts.length') {{ $t('order.order_detail.charge_discounts_no_data') }}
          //- Tabla cargos y descuentos
          ods-table(
            v-if='chargesDiscounts.length > 0 ',
            :data='chargesDiscounts',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            @selection-change='handleSelectionChange',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              width='225'
              prop='chargeDiscountTypeCode',
              :label='$t("order.order_charges_discounts_table.chargeDiscountTypeCode")',
              :show-overflow-tooltip='true')
              template(slot-scope='scope')
                span(v-if="scope.row.chargeDiscountTypeCode === 'TD'") {{ $t('order.order_charges_discounts_table.charge_code.TD') }}
                span(v-else-if="scope.row.chargeDiscountTypeCode === 'EAB'") {{ $t('order.order_charges_discounts_table.charge_code.EAB') }}
                span(v-else-if="scope.row.chargeDiscountTypeCode === 'ABH'") {{ $t('order.order_charges_discounts_table.charge_code.ABH') }}
                span(v-else-if="scope.row.chargeDiscountTypeCode === 'ACQ'") {{ $t('order.order_charges_discounts_table.charge_code.ACQ') }}
                span(v-else-if="scope.row.chargeDiscountTypeCode === 'MC'") {{ $t('order.order_charges_discounts_table.charge_code.MC') }}
                span(v-else-if="scope.row.chargeDiscountTypeCode === 'VEJ'") {{ $t('order.order_charges_discounts_table.charge_code.VEJ') }}
                span(v-else-if="scope.row.chargeDiscountTypeCode === 'AA'") {{ $t('order.order_charges_discounts_table.charge_code.AA') }}
                span(v-else) {{ scope.row.chargeDiscountTypeCode }}
            ods-table-column(
              prop='charge',
              :label='$t("order.order_charges_discounts_table.charge")',
              :show-overflow-tooltip='true')
              template(slot-scope='scope')
                span(v-if="scope.row.charge === 'CHARGE'") {{ $t('charge_type.CHARGE') }}
                span(v-else-if="scope.row.charge === 'DISCOUNT'") {{ $t('charge_type.DISCOUNT') }}
                span(v-else) {{ scope.row.charge }}
            ods-table-column(
              prop='rate',
              :label='$t("order.order_charges_discounts_table.rate")',
              :show-overflow-tooltip='true',
              :formatter='formatterStandardQuantity')
            ods-table-column(
              prop='baseAmount',
              :label='$t("order.order_charges_discounts_table.baseAmount")',
              :show-overflow-tooltip='true',
              :formatter='formatterStandardQuantity')
            ods-table-column(
              prop='amount',
              :label='$t("order.order_charges_discounts_table.amount")',
              :show-overflow-tooltip='true',
              :formatter='formatterStandardQuantity')
            ods-table-column(
              prop='currencyCode',
              :label='$t("order.order_charges_discounts_table.currencyCode")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='sequence',
              :label='$t("order.order_charges_discounts_table.sequence")',
              :show-overflow-tooltip='true')

    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='canChangeStatusOrder'
            type='primary',
            size='large'
            @click='submitOrderDetailEditForm')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            v-if='canChangeStatusOrder'
            ref='buttonCancel',
            size='large'
            type='neutral',
            @click='cancelOrderDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse
      ods-accordion(v-model='activateRelatedDocuments', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('order.order_detail.related_documents') }}
            span.info(v-show='!relatedDocuments.length') {{ $t('order.order_detail.related_documents_no_data') }}
          //- Tabla documentos relacionados
          ods-table(
            v-if='relatedDocuments.length > 0 ',
            :data='relatedDocuments',
            style='width: 100%',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='idDestinationDocument',
              :label='$t("order.order_related_documents_table.destinationDocument")')
              template(slot-scope='scope')
                span(v-if='scope.row.idDestinationDocument')
                a(
                  @click='goToDetail(scope.row.idDestinationDocument, scope.row.destinationDocumentType)',
                  style='color: var(--color-bg-interactive); cursor: pointer;'
                )
                  | {{ scope.row.destinationDocumentNumber }}
            ods-table-column(
              prop='destinationDocumentType',
              :label='$t("order.order_related_documents_table.destinationDocumentType")')
              template(slot-scope='scope')
                span(v-if="scope.row.destinationDocumentType === 'INVOICE'") {{ $t('document_type.INVOICE') }}
                span(v-else-if="scope.row.destinationDocumentType === 'PURCHASEORDER'") {{ $t('document_type.PURCHASEORDER') }}
                span(v-else-if="scope.row.destinationDocumentType === 'DELIVERYNOTE'") {{ $t('document_type.DELIVERYNOTE') }}
                span(v-else-if="scope.row.destinationDocumentType === 'RECEIVEADVICE'") {{ $t('document_type.RECEIVEADVICE') }}
                span(v-else) {{ scope.row.destinationDocumentType }}
            ods-table-column(
              prop='creationDateTime'
              :label='$t("order.order_related_documents_table.date")',
              :formatter='dateFormatted')

    ods-module.collapse
      ods-accordion(v-model='activateOrderResponse', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('order.order_detail.order_reponse') }}
            span.info(v-show='!ordersResponse.length') {{ $t('order.order_detail.order_response_no_data') }}

          //- Tabla respuestas de pedido
          ods-table(
            v-if='ordersResponse.length > 0 ',
            :data='ordersResponse',
            :default-sort="{prop: 'creationDate', order: 'descending'}",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='orderResponseNumber',
              :label='$t("order.order_detail.order_reponse_number")',
              sortable='')
            //- ods-table-column(
            //-   prop='orderResponseName',
            //-   :label='$t("order.order_detail.order_reponse_name")',
            //-   :show-overflow-tooltip='true',
            //-   sortable='')
            ods-table-column(
              prop='creationDate',
              :label='$t("order.order_detail.order_reponse_date")',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              width='115'
              align='center',
              :label='$t("order.order_entity_table_detail.options")'
              :show-overflow-tooltip='true'
              sortable='')
              template(slot-scope="scope")
                //- Descargar pdf order response
                ods-tooltip(placement='left')
                  template(slot='content')
                    | {{ $t('buttons.btnDownloadPdf') }}
                  ods-button(
                    style=' padding-left: 0px; padding-right: 0px;'
                    type='neutral',
                    icon-position='left'
                    @click="handleDownloadOrderResponsePdf(scope.row)")
                    ods-icon(name='download', size='16')
                //- Descargar XML order response
                ods-tooltip(placement='left')
                  template(slot='content')
                    | {{ $t('buttons.btnDownloadOrderRsp') }}
                  ods-button(
                    style=' padding-left: 0px; padding-right: 0px;'
                    type='neutral',
                    @click="handleDownloadOrderResponse(scope.row)")
                    ods-icon(name='download', size='16')

    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='canChangeStatusOrder && multipleSelection.length && ("RECEIVED" == orderStatus || "PARTIALLY_SENT" == orderStatus || "FULLY_SENT" == orderStatus)',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-tooltip(:content='$t("order.order_detail.change_line_status_buttons_tooltip")', placement='bottom', size='large')
            ods-button(
                icon='ods-icon-sync',
                size='small',
                circle,
                @click.native='handleChangeOrderLinesStatus')
                | {{ $t('order.order_detail.change_line_status_buttons') }}
    //- Dialog CAmbio de estado -- dropdown
    ods-dialog(
      ref='dialogChangeOrderLinesStatus',
      :title='$t("order.order_entity_table_detail.change_state.title")',
      :visible.sync='isShowDialogChangeOrderLinesStatus',
      @close='handleCloseDialogChangeOrderLinesStatus'
      width='30%')
      ods-form(
        ref='formDialogChangeOrderLinesStatus',
        :model='formDialogChangeOrderLinesStatus',
        :rules='rulesDialogChangeOrderLinesStatus')
        ods-form-item(
          :label='$t("order.order_entity_table_detail.change_state.label")',
          prop='statusCode')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='formDialogChangeOrderLinesStatus.statusCode',
            filterable,
            :placeholder='$t("order.order_entity_table_detail.change_state.placeholder")'
            @change='changeOrderLineStatus')
            ods-option(
              v-for='option in optionsFilterStatusOrderLines',
              :key='option.id',
              :label='$t("order_status." + option.code)',
              :value='option.code')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='submitChangeOrderLinesStatus("formDialogChangeOrderLinesStatus")')
          | {{ $t('buttons.btnConfirm') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTableLinesOrdersEmit from '@/views/pedidos/emitidos/B2bTableLinesOrdersEmit'
import B2bTimeline from '@/components/B2bTimeline'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-orders-emits',
  mixins: [Utils],
  data () {
    return {
      activateLines: ['1'],
      activateDetail: ['1'],
      activateChargeDiscounts: ['1'],
      activateRelatedDocuments: ['1'],
      activateOrderResponse: ['0'],
      ordersEmitLine: [],
      relatedDocuments: [],
      ordersEmitLineOriginal: [],
      chargesDiscounts: [],
      ordersResponse: [],
      deliveryCentreFilters: [],
      deliveryDateFromFilter: null,
      deliveryDateToFilter: null,
      statusDocumentOrder: null,
      orderStatus: null,
      measureUnit: '',
      searchType: 'EMITTED',
      dialogNewLineOrderForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null
      },
      orderDetailForm: {
        buyerName: null,
        sellerName: null,
        orderNumber: null,
        issueDateTime: '',
        creationDateTime: '',
        documentStatus: null,
        projectName: null,
        statusId: null,
        statusCode: null,
        observations: null
      },
      multipleSelection: [],
      multipleSelectionIds: [],

      viewUpdate: false,

      formDialogChangeOrderLinesStatus: {
        statusCode: null
      },

      optionsFilterStatusOrderLines: [],

      currentRow: {},
      orderLinesChanged: [],
      isShowDialogCheckLine: false,
      isShowDialogCheckLineEdit: false,
      isShowDialogChangeOrderLinesStatus: false,
      rulesDialogNewLineOrderForm: {
        description: [{
          required: true,
          message: this.$t('order.order_detail.dialog_new_check_line_order.date_required'),
          trigger: 'change'
        },
        {
          max: 80,
          message: this.$t('validations.maxlenght', { maxlenght: 80 }),
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          message: this.$t('order.order_detail.dialog_new_check_line_order.date_required'),
          trigger: 'change'
        }],
        priceUnit: [{
          required: true,
          message: this.$t('order.order_detail.dialog_new_check_line_order.date_required'),
          trigger: 'change'
        }]
      },
      rulesDialogNewLineEditOrderForm: {
        description: [{
          required: true,
          message: this.$t('order.order_detail.dialog_new_check_line_order.date_required'),
          trigger: 'change'
        },
        {
          max: 80,
          message: this.$t('validations.maxlenght', { maxlenght: 80 }),
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          message: this.$t('order.order_detail.dialog_new_check_line_order.date_required'),
          trigger: 'change'
        }],
        priceUnit: [{
          required: true,
          message: this.$t('order.order_detail.dialog_new_check_line_order.date_required'),
          trigger: 'change'
        }]
      },
      rulesDialogChangeOrderLinesStatus: {
        statusCode: [{
          required: true,
          message: this.$t('msg_generics.field_required'),
          trigger: 'change'
        }]
      },
      optionsMeasure: [],
      searchMeasure: [],
      dialogNewLineEditOrderForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null,
        orderIdLine: null
      }
    }
  },

  components: {
    B2bTimeline,
    B2bTableLinesOrdersEmit,
    B2bTableSelectRows
  },

  computed: {
    ...mapGetters([
      'optionsFilterStatusOrder',
      // Permisos
      'canChangeStatusOrder',
      'canViewOrderOriginal',
      'canViewOrderMetadata',
      'isShowItemCodeLinesEmit',
      'isShowItemCodeSellerLinesEmit',
      'isShowItemCodeBuyerLinesEmit',
      'isShowGtin14CodeLinesEmit',
      'isShowCentroEntregaLinesEmit',
      'isShowDescriptionLinesEmit',
      'isShowStatusLinesEmit',
      'isShowQuantityLinesEmit',
      'isShowMeasureLinesEmit',
      'isShowUnitOfMeasureTradeUnitLinesEmit',
      'isShowNetPriceLinesEmit',
      'isShowGrossPriceLinesEmit',
      'isShowCurrencyLinesEmit',
      'isShowTotalAmountLinesEmit',
      'isShowDeliveryDateFromLinesEmit',
      'isShowDeliveryDateToLinesEmit',
      'isShowQuantityTradeUnitLinesEmit',
      'isShowQuantityRemainingEmit'
    ]),

    issueDateTimeFormatted () { // eslint-disable-line
      if (this.orderDetailForm.issueDateTime) {
        const date = moment(this.orderDetailForm.issueDateTime)
        return date.format('DD/MM/YYYY')
      }
    },
    deliveryDateFromFormatted () { // eslint-disable-line
      if (this.orderDetailForm.deliveryDateFrom) {
        const date = moment(this.orderDetailForm.deliveryDateFrom)
        return date.format('DD/MM/YYYY HH:mm')
      }
    },
    deliveryDateToFormatted () { // eslint-disable-line
      if (this.orderDetailForm.deliveryDateTo) {
        const date = moment(this.orderDetailForm.deliveryDateTo)
        return date.format('DD/MM/YYYY HH:mm')
      }
    },
    creationDateTimeFormatted () { // eslint-disable-line
      if (this.orderDetailForm.creationDateTime) {
        const date = moment(this.orderDetailForm.creationDateTime)
        return date.format(this.$t('date_format_long'))
      }
    },
    orderDetailFormRules () {
      const checkObservations = (rule, value, callback) => {
        const self = this
        const estado = this.optionsFilterStatusOrder.find(function (t) {
          return t.code === self.orderDetailForm.statusCode
        })
        const observations = this.orderDetailForm.observations
        if (estado && estado.code === 'REJECTED' && !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      return {
        observations: [
          { max: 256, message: this.$t('msg_generics.max_num_character', { max: 256 }), trigger: 'blur' },
          { validator: checkObservations, trigger: 'blur, change' }
        ]
      }
    }
  },

  watch: {
    deliveryDateFromFilter: 'filterOrderLinesTable',
    deliveryDateToFilter: 'filterOrderLinesTable'
  },

  methods: {
    ...mapActions([
      'modifyOrder',
      'modifyOrderLines',
      'getOrderLines',
      'getRelatedDocuments',
      'getChargesDiscounts',
      'getOrderResponses',
      'getOrderDetail',
      'downloadOrderPdfMultiple',
      'getOrdersMeasure',
      'downloadOrderOriginal',
      'downloadOrderMetadata',
      'downloadOrderResponseDocument',
      'downloadOrderResponsePdf'
    ]),
    changeStatus (data) {
      this.optionsFilterStatusOrder.find(function (t) {
        return t.id === data
      })
      this.$refs.orderDetailForm.clearValidate()
    },
    changeOrderLineStatus (data) {
      this.optionsFilterStatusOrderLines.find(function (t) {
        return t.code === data
      })
      this.$refs.formDialogChangeOrderLinesStatus.clearValidate()
    },

    submitOrderDetailEditForm () {
      const orderId = this.$route.params.orderId
      this.$refs.orderDetailForm.validate(async (valid) => {
        if (valid && orderId != '_blank') {// eslint-disable-line
          const load = this.$loading({
            lock: true,
            text: this.$t('order.order_detail.change_state.load')
          })
          console.log('submitOrderDetailEditForm: ', this.orderDetailForm)
          try {
            const dataQuery = {
              query: {
                statusCode: this.orderDetailForm.statusCode,
                observations: this.orderDetailForm.observations,
                searchType: this.searchType
              }
            }
            const params = {
              orderId: orderId,
              dataQuery: dataQuery
            }
            await this.modifyOrder(params)

            // Reseteamos los campos
            this.$refs.orderDetailForm.clearValidate()
            this.orderDetailForm.statusId = this.$t('order_status.' + this.orderDetailForm.statusCode)
            const length = this.ordersEmitLine.length
            if (length > 0) {
              for (let i = 0; i < length; i++) {
                this.ordersEmitLine[i].status = this.orderDetailForm.statusCode
              }
            }

            this.orderDetailForm.statusCode = null
            this.orderDetailForm.observations = null

            this.$notify({
              title: this.$t('order.order_detail.notify.submit_edit_order_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitOrderDetailEditForm CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs.orderDetailForm.resetFields()
          } finally {
            load.close()
          }
        } else {
          console.log('submitOrderDetailEditForm: ', this.orderDetailForm)
          return false
        }
      })
    },

    submitChangeOrderLinesStatus () {
      const orderId = this.$route.params.orderId
      this.$refs.formDialogChangeOrderLinesStatus.validate(async (valid) => {
        if (valid && orderId != '_blank' && orderId != 'creacion') {// eslint-disable-line
          const load = this.$loading({
            lock: true,
            text: this.$t('order.order_entity_table_detail.change_state.load')
          })
          console.log('submitChangeOrderLinesStatus: ', this.formDialogChangeOrderLinesStatus)
          try {
            const dataQuery = {
              query: {
                statusCode: this.formDialogChangeOrderLinesStatus.statusCode,
                lineIds: this.multipleSelectionIds,
                searchType: this.searchType
              }
            }
            const params = {
              orderId: orderId,
              dataQuery: dataQuery
            }

            await this.modifyOrderLines(params)

            // Reseteamos los campos
            this.isShowDialogChangeOrderLinesStatus = false
            this.formDialogChangeOrderLinesStatus.statusCode = null
            this.multipleSelection = []
            this.multipleSelectionIds = []

            this.$refs.formDialogChangeOrderLinesStatus.resetFields()

            // Detalle pedido
            await this.getOrdersEmitOnDatabase()
            // Get Lineas pedido
            await this.getOrdersLinesEmitOnDatabase()
            // Get Documentos relacionados
            await this.getRelatedDocumentsOnDatabase()
            // Get cargos y descuentos
            await this.getChargesDiscountsOnDatabase()
            // Get respuestas de pedido
            await this.getOrdersResponsesEmitOnDatabase()

            this.$notify({
              title: this.$t('order.order_detail.notify.order_edit_line'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitChangeOrderLinesStatus CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs.formDialogChangeOrderLinesStatus.resetFields()
          } finally {
            load.close()
          }
        } else {
          console.log('submitChangeOrderLinesStatus: ', this.formDialogChangeOrderLinesStatus)
          return false
        }
      })
    },

    async cancelOrderDetailEditForm () {
      this.$refs.buttonCancel.$el.blur()
      this.orderDetailForm.statusCode = null
      this.orderDetailForm.observations = null
    },
    formatterRole (row, column) {
      if (row[column.property]) {
        return this.$t('centre_role_type_order.' + row[column.property])
      }
      return ''
    },
    dateFormatted (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    handleSelectionChange (val) {
      this.multipleSelection = val
      this.multipleSelectionIds = []

      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelection = this.multipleSelection.filter(item => {
        const param = item.id
        this.multipleSelectionIds.push(param)
        return item
      })
    },
    renderHeaderActions: h => {
      return <B2bTableLinesOrdersEmit />
    },

    resetBorderColor () {
      // get element by class
      const arr = document.getElementsByClassName('ods-button ods-tooltip bordered')

      // store length in variable
      // some say accessing .length in a loop condition adds overhead
      const arrLen = arr.length

      // loop through all found elements
      for (let i = 0; i < arrLen; i++) {
        if (arr[i].style) {
          arr[i].style.border = ''
        }
      }
    },

    formatterStatus (row, column) {
      return row.status != null ? this.$t('order_status.' + row.status) : null
    },
    formatterDecimal (row, column) {
      if (row[column.property] == null) {
        return this.$t('msg_generics.no_price')
      } else if (row[column.property] || row[column.property] === 0) {
        return this.$n(row[column.property], 'two_to_six_decimal')
      }
      return ''
    },
    formatterQuantity (value) {
      if (value) {
        return this.$n(value, 'three_decimal')
      }
      return ''
    },
    formatterStandardQuantity (row, column) {
      if (row[column.property]) {
        return this.$n(row[column.property], 'decimal')
      }
      return ''
    },
    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    // Descarga de pdf
    async handleDownloadOrderPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const idList = [this.$route.params.orderId]
        const filename = await this.downloadOrderPdfMultiple({
          ordersId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadOriginal () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const idList = [this.$route.params.orderId]
        const filename = await this.downloadOrderOriginal({
          orderId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadMetadata () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const idList = [this.$route.params.orderId]
        const filename = await this.downloadOrderMetadata({
          orderId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    handleChangeOrderLinesStatus () {
      this.isShowDialogChangeOrderLinesStatus = true
    },
    handleCloseDialogChangeOrderLinesStatus () {
      this.isShowDialogChangeOrderLinesStatus = false
      this.formDialogChangeOrderLinesStatus.statusCode = null
    },
    // Lineas de una pedidos
    async getOrdersLinesEmitOnDatabase () {
      // Get datos lineas  de la pedido
      try {
        if (this.$route.params.orderId && this.$route.params.orderId !== 'creacion' && this.$route.params.orderId !== '_blank') {
          const dataQuery = {
            query: {
              searchType: this.searchType,
              orderId: this.$route.params.orderId
            }
          }
          const response = await this.getOrderLines(dataQuery)
          this.ordersEmitLine = response.data
          this.ordersEmitLineOriginal = this.ordersEmitLine

          this.optionsFilterStatusOrderLines = this.optionsFilterStatusOrder.filter(function (t) {
            return t.code === 'RECEIVED' || t.code === 'PARTIALLY_SENT' || t.code === 'FULLY_SENT'
          })
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Documentos relacionados
    async getRelatedDocumentsOnDatabase () {
      // Get documentos relacionados del pedido
      try {
        if (this.$route.params.orderId && this.$route.params.orderId !== 'creacion' && this.$route.params.orderId !== '_blank') {
          const dataQuery = {
            query: {
              searchType: this.searchType,
              orderId: this.$route.params.orderId
            }
          }
          const response = await this.getRelatedDocuments(dataQuery)
          this.relatedDocuments = response.data
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Cargos y descuentos
    async getChargesDiscountsOnDatabase () {
      // Get cargos y descuentos del pedido
      try {
        if (this.$route.params.orderId && this.$route.params.orderId !== 'creacion' && this.$route.params.orderId !== '_blank') {
          const dataQuery = {
            query: {
              searchType: this.searchType,
              orderId: this.$route.params.orderId
            }
          }
          const response = await this.getChargesDiscounts(dataQuery)
          this.chargesDiscounts = response.data
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Enlace al detalle del documento y tipo de documento
    async goToDetail (documentId, documentType) {
      console.log('Go to detail: ', documentId)
      console.log('Go to document type: ', documentType)
      if (documentType === 'DELIVERYNOTE') {
        router.push({
          name: 'delivery-note-received-detail',
          params: {
            deliveryId: documentId
          }
        })
      } else if (documentType === 'INVOICE') {
        router.push({
          name: 'factura-recibida-detail',
          params: {
            invoiceNoteId: documentId
          }
        })
      } else if (documentType === 'PURCHASEORDER') {
        router.push({
          name: 'order-emit-detail',
          params: {
            orderId: documentId
          }
        })
      } else if (documentType === 'RECEIVEADVICE') {
        router.push({
          name: 'recadv-emit-detail',
          params: {
            recadvId: documentId
          }
        })
      }
    },

    // Rellena los centros de entrega para el filtro de la columna 'lugar de entrega' de la tabla líneas de pedidos
    fillDeliveryCentreFilters () {
      const separator = ' - '
      // Obtenemos los valores únicos de la propiedad centreDeliveryPoint
      const uniqueValues = [...new Set(this.ordersEmitLine.map(item => item.centreDeliveryPoint + separator + item.centreDeliveryPointTooltip))]
      // Crea los objetos de filtro y asigna al array deliveryCentreFilters
      this.deliveryCentreFilters = uniqueValues.map(value => ({
        text: value,
        value: value.split(separator)[0]
      }))
    },

    filterDeliveryCentreHandler (value, row) {
      // aplicamos la lógica para hacer efectivo el filtro de la columna lugar de entrega:
      return row.centreDeliveryPoint === value
    },

    filterOrderLinesTable () {
      // Lógica para filtrar los datos de la tabla líneas pedido por fechas
      const startDate = this.deliveryDateFromFilter
      const endDate = this.deliveryDateToFilter
      console.log('startDate', startDate)
      console.log('endDate', endDate)
      this.ordersEmitLine = this.ordersEmitLineOriginal // reset

      this.ordersEmitLine = this.ordersEmitLine.filter((item) => {
        const itemStartDate = new Date(item.deliveryDateFrom)
        const itemEndDate = new Date(item.deliveryDateTo)
        if (startDate != null && endDate != null) {
          return itemStartDate >= startDate && itemEndDate <= endDate
        } else if (startDate != null) {
          return itemStartDate >= startDate
        } else if (endDate != null) {
          return itemEndDate <= endDate
        } else { // si ambas son null es que no hay filtro aplicado por fechas
          return true
        }
      })
      // recargamos el filtro lugar de entrega
      this.fillDeliveryCentreFilters()
    },

    // Respuestas del pedido
    async getOrdersResponsesEmitOnDatabase () {
      // Get respuestas
      try {
        if (this.$route.params.orderId && this.$route.params.orderId !== 'creacion' && this.$route.params.orderId !== '_blank') {
          const dataQuery = {
            query: {
              searchType: this.searchType,
              orderId: this.$route.params.orderId
            }
          }
          const response = await this.getOrderResponses(dataQuery)
          this.ordersResponse = response.data
          if (this.ordersResponse.length > 0) {
            this.activateOrderResponse = ['1']
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async handleDownloadOrderResponse (row) {
      console.log('handleDownloadOrderResponse: ', row.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const orderResponseIds = [row.id]
        const filename = await this.downloadOrderResponseDocument({
          orderResponseId: orderResponseIds,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOrderResponse CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descarga de pdf de order response
    async handleDownloadOrderResponsePdf (row) {
      console.log('handleDownloadOrderResponsePdf: ', row.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const filename = await this.downloadOrderResponsePdf({
          orderResponseId: row.id,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Detalle Pedido
    async getOrdersEmitOnDatabase () {
      try {
        if (this.$route.params.orderId && this.$route.params.orderId !== 'creacion' && this.$route.params.orderId !== '_blank') {
          this.orderDetailForm = await this.getOrderDetail({
            orderID: this.$route.params.orderId,
            searchType: this.searchType
          })
          // Guardamos estado
          this.orderStatus = this.orderDetailForm.statusId
          this.statusDocumentOrder = this.orderDetailForm.documentStatus
          // Formateamos estado
          if (this.orderStatus != null && this.orderStatus === 'REJECTED' && this.orderDetailForm.rejectSeller) {
            const REJECTED_SELLER = 'REJECTED_SELLER'
            this.orderDetailForm.statusId = this.$t('order_status.' + REJECTED_SELLER)
          } else {
            this.orderDetailForm.statusId = this.$t('order_status.' + this.orderDetailForm.statusId)
          }
          if (this.orderDetailForm.orderType) {
            this.orderDetailForm.orderType = this.$t('order_type.' + this.orderDetailForm.orderType)
          }
          if (this.orderDetailForm.orderSubType) {
            this.orderDetailForm.orderSubType = this.$t('order_subtype.' + this.orderDetailForm.orderSubType)
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      console.log('orderId: ', this.$route.params.orderId)
      if (this.$route.params.orderId && this.$route.params.orderId !== 'creacion' && this.$route.params.orderId !== '_blank') {
        // Detalle pedido
        await this.getOrdersEmitOnDatabase()
        // Get Lineas pedido
        await this.getOrdersLinesEmitOnDatabase()
        // Get Documentos relacionados
        await this.getRelatedDocumentsOnDatabase()
        // Get cargos y descuentos
        await this.getChargesDiscountsOnDatabase()
        // Get respuestas de pedido
        await this.getOrdersResponsesEmitOnDatabase()
        // Rellenamos el array del filtro de lugar de entrega
        this.fillDeliveryCentreFilters()
      }
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-orders-emits {
  ::v-deep .ods-input__inner {
    background-color: transparent !important;
  }
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 0px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .moreSpace {
    margin-bottom: 0px;
  }
  .ods-form-item {
    margin-bottom: 0px;
    margin-top: 1rem;
  }
  ::v-deep .ods-form-item__label {
    font-weight: 500;
  }

  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 0px;
  }
  .collapse{
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .dateFilter {
      font-size: 12px;
      padding: 0 28px 0 20px;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
      ::v-deep .ods-button{
      background-color: #FFF;
      border-color: #FFF;
      color: #000;
      }
      ::v-deep .ods-input-number .ods-input__inner {
        padding: 4px 30px 4px 8px;
        text-align: right;
      }
    }
    ::v-deep .ods-input.is-disabled .ods-input__inner{
      background-color: transparent;
      border-color: transparent;
      color: black;
      cursor: not-allowed;
      text-align: right;
    }
    ::v-deep .ods-scrollbar__bar.is-horizontal, .ods-scrollbar__bar.is-horizontal {
      opacity: 1;
    }
    ::v-deep .ods-scrollbar__wrap.ods-table__body-wrapper {
      margin-bottom: 20px;
    }
    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
    ::v-deep .ods-date-editor.ods-input {
        width: 120px;
        margin-right: 24px;
      }
  }
  ::v-deep.ods-table__body-wrapper {
    margin-bottom: 20px !important;
  }
}
</style>
